export default "__VITE_ASSET__Ls4$FaFg__"